import { createSlice, nanoid } from "@reduxjs/toolkit";

const getNewMessage = (payload) => ({
  id: payload.id,
  title: payload.title,
  message: payload.message,
  detail: payload.detail,
  type: payload.type,
  actionUrl: payload.actionUrl,
  actionLabel: payload.actionLabel,
  customAction: payload.customAction,
  autoHideDuration: payload.autoHideDuration // optional per-toast override
});

const preparePayload = (message, type) => ({
  payload: {
    id: message?.id ?? nanoid(),
    title: message?.title,
    message: message?.title ?? message,
    detail: message?.detail,
    type,
    actionUrl: message?.actionUrl,
    actionLabel: message?.actionLabel,
    customAction: message?.customAction,
    autoHideDuration: message?.autoHideDuration
  },
});

const toastSlice = createSlice({
  name: "toast",
  initialState: {
    messages: [],
  },
  reducers: {
    showSuccessMessage: {
      reducer(state, action) {
        state.messages.push(getNewMessage(action.payload));
      },
      prepare(message) {
        return preparePayload(message, "success");
      },
    },
    showWarningMessage: {
      reducer(state, action) {
        state.messages.push(getNewMessage(action.payload));
      },
      prepare(message) {
        return preparePayload(message, "warning");
      },
    },
    showErrorMessage: {
      reducer(state, action) {
        state.messages.push(getNewMessage(action.payload));
      },
      prepare(message) {
        return preparePayload(message, "error");
      },
    },
    showInfoMessage: {
      reducer(state, action) {
        state.messages.push(getNewMessage(action.payload));
      },
      prepare(message) {
        return preparePayload(message, "info");
      },
    },
    showReminderMessage: {
      reducer(state, action) {
        state.messages.push(getNewMessage(action.payload));
      },
      prepare(message) {
        return preparePayload(message, "reminder");
      },
    },
    removeMessage(state, action) {
      state.messages = state.messages.filter((t) => t.id !== action.payload);
    },
  },
});

export const toastActions = toastSlice.actions;
export default toastSlice.reducer;
